import { useCallback } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import ToggleButton from './..';
import Icon from 'components/Kizen/Icon';

export const ICON_TOGGLE_BUTTON_SIZINGS = {
  default: 'default',
  compact: 'compact',
};

export const COLORS_ICON_TOGGLE_BUTTON = {
  blue: {
    selected: 'var(--color-background-white)',
    default: {
      hover: 'var(--color-button-secondary-hover)',
      default: 'var(--color-button-secondary-default)',
    },
  },
  disabled: {
    selected: 'var(--color-background-dark)',
    default: 'var(--color-button-disabled-default)',
  },
};

export const useIconToggleButton = (options, color, disabled) => {
  const getViewOptions = useCallback(
    (currentValue) => {
      const colours = disabled ? COLORS_ICON_TOGGLE_BUTTON.disabled : color;
      return options.map(({ value, icon }) => ({
        value,
        label: (
          <Icon
            icon={icon}
            color={currentValue === value ? colours.selected : colours.default}
          />
        ),
      }));
    },

    [options, color, disabled]
  );

  return { getViewOptions };
};

export const IconToggleButton = styled(ToggleButton)`
  && button {
    height: 28px;
    padding-top: 0;

    i {
      height: auto;
      svg {
        height: auto;
      }
    }

    ${({ sizing = ICON_TOGGLE_BUTTON_SIZINGS.default }) =>
      sizing === ICON_TOGGLE_BUTTON_SIZINGS.compact
        ? css`
            width: 33px;
            i {
              width: 12px;
              svg {
                width: 12px;
              }
            }
          `
        : css`
            width: 44px;
            i {
              width: 14px;
              svg {
                width: 14px;
              }
            }
          `}
  }
`;
